// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";
import * as CatalogPriceLookUpInput from "./CatalogPriceLookUpInput.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

function CatalogVariantEditFormInputs$InputVariantCapacityValueSelect(props) {
  let match = CatalogVariantEditForm.useFormState().values;
  let inputPlaceholder = CatalogVariant.CapacityValue.placeholderFromProductKind(props.productKind);
  let unit = Stdlib_Option.getOr(match.capacityUnit, "custom");
  let inputPrecision = unit === CatalogVariant.CapacityUnit.kg || unit === CatalogVariant.CapacityUnit.l ? 2 : (
      unit === CatalogVariant.CapacityUnit.cl ? 1 : (
          unit === CatalogVariant.CapacityUnit.ml || unit === CatalogVariant.CapacityUnit.g ? 0 : 3
        )
    );
  return JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
    field: "CapacityValue",
    label: I18n.t("Capacity"),
    placeholder: inputPlaceholder,
    minValue: 0,
    precision: inputPrecision
  });
}

let InputVariantCapacityValueSelect = {
  make: CatalogVariantEditFormInputs$InputVariantCapacityValueSelect
};

function CatalogVariantEditFormInputs$InputVariantCapacityUnitSelect(props) {
  let disabled = props.disabled;
  let match = CatalogVariantEditForm.useFormState().values;
  let bulk = match.bulk;
  let capacityUnit = match.capacityUnit;
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let options = CatalogVariant.CapacityUnit.makeOptions(props.productKind);
  React.useEffect(() => {
    if (bulk && Stdlib_Option.isNone(capacityUnit)) {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "CapacityUnit",
        _1: param => options[0]
      });
    }
  }, [bulk]);
  let tooltip = bulk ? (
      disabled ? JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("The capacity unit cannot be changed.")
        }) : JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Once the product has been created in bulk, the capacity unit can't be modified.")
        })
    ) : undefined;
  let defaultItem_1 = I18n.template(I18n.t("Piece"), undefined, undefined);
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = options.map(unit => ({
    TAG: "Option",
    key: unit,
    label: unit,
    value: unit
  }));
  let sections = [{
      items: bulk ? items : Belt_Array.concatMany([
          items,
          [defaultItem]
        ])
    }];
  return JsxRuntime.jsx(CatalogVariantEditForm.InputSelect.make, {
    field: "CapacityUnit",
    label: I18n.t("Capacity unit"),
    tooltip: tooltip,
    disabled: disabled,
    placeholder: I18n.t("Select an unit"),
    searchable: false,
    sections: sections
  });
}

let InputVariantCapacityUnitSelect = {
  make: CatalogVariantEditFormInputs$InputVariantCapacityUnitSelect
};

function CatalogVariantEditFormInputs$InputVariantYear(props) {
  return JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
    field: "Year",
    label: I18n.t("Vintage"),
    hideStepper: true,
    placeholder: CatalogVariant.Year.placeholderFromProductKind(props.productKind),
    useGrouping: false,
    minValue: 0,
    maxValue: new Date().getFullYear(),
    precision: 0
  });
}

let InputVariantYear = {
  make: CatalogVariantEditFormInputs$InputVariantYear
};

function CatalogVariantEditFormInputs$InputVariantAlcoholVolume(props) {
  return JsxRuntime.jsx(CatalogVariantEditForm.InputOptionalNumber.make, {
    field: "AlcoholVolume",
    label: I18n.t("Alcohol volume"),
    placeholder: CatalogVariant.Volume.placeholderFromProductKind(props.productKind),
    appender: "Percent",
    minValue: 0,
    maxValue: 100
  });
}

let InputVariantAlcoholVolume = {
  make: CatalogVariantEditFormInputs$InputVariantAlcoholVolume
};

function CatalogVariantEditFormInputs$InputVariantPriceLookup(props) {
  let match = CatalogVariantEditForm.useFormState();
  let validation = match.validation;
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let priceLookUpCodeError;
  priceLookUpCodeError = validation.TAG === "Ok" ? undefined : Stdlib_Array.filterMap(validation._0, param => {
        if (param[0]._0 === "PriceLookUpCode") {
          return param[1];
        }
      })[0];
  let onAlreadyConsummedValuesFetched = values => dispatch({
    TAG: "FieldValueChanged",
    _0: "PriceLookUpCode",
    _1: previous => ({
      invalidValues: values,
      value: previous.value
    })
  });
  let onChange = value => dispatch({
    TAG: "FieldValueChanged",
    _0: "PriceLookUpCode",
    _1: previous => ({
      invalidValues: previous.invalidValues,
      value: value
    })
  });
  return JsxRuntime.jsx(CatalogPriceLookUpInput.make, {
    value: match.values.priceLookUpCode.value,
    errorMessage: priceLookUpCodeError,
    onAlreadyConsummedValuesFetched: onAlreadyConsummedValuesFetched,
    onChange: onChange
  });
}

let InputVariantPriceLookup = {
  make: CatalogVariantEditFormInputs$InputVariantPriceLookup
};

let Raw = {};

let query = Client.gql(["query CatalogVariantEditFormSkuDuplicateCheckQuery($filterBy: InputVariantsQueryFilter)  {\nvariants(filterBy: $filterBy, first: 5)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \nformattedName  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  return {
    variants: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            formattedName: value$1.formattedName
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedName;
    let value$3 = value$1.cku;
    let value$4 = Scalar.CKU.serialize(value$3);
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      cku: value$4,
      formattedName: value$2
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variants = {
    __typename: value$3,
    edges: edges
  };
  return {
    variants: variants
  };
}

function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    ean13: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    active: a$3 !== undefined ? ({
        _equals: a$3._equals
      }) : undefined,
    archived: a$4 !== undefined ? (
        a$4 === "ONLY" ? "ONLY" : (
            a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? ({
        _equals: a$10._equals
      }) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputVariantsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let DuplicateCheckQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let DuplicateCheckQuery_refetchQueryDescription = include.refetchQueryDescription;

let DuplicateCheckQuery_useLazy = include.useLazy;

let DuplicateCheckQuery_useLazyWithVariables = include.useLazyWithVariables;

let DuplicateCheckQuery = {
  DuplicateCheckQuery_inner: DuplicateCheckQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: DuplicateCheckQuery_refetchQueryDescription,
  use: use,
  useLazy: DuplicateCheckQuery_useLazy,
  useLazyWithVariables: DuplicateCheckQuery_useLazyWithVariables
};

function CatalogVariantEditFormInputs$InputVariantStockKeepingUnit(props) {
  let match = CatalogVariantEditForm.useFormState();
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let activeShop = Auth.useActiveShop();
  let value = match.values.stockKeepingUnit;
  let currentVariantId = props.editionMode ? match.id : undefined;
  let match$1 = React.useState(() => {});
  let setDuplicate = match$1[1];
  let duplicate = match$1[0];
  let debouncedValue = ReactUpdateDebounced.use(value, 400);
  let ready = debouncedValue.trim() !== "" && Stdlib_Option.isSome(activeShop);
  ReactUpdateEffect.use1(() => {
    setDuplicate(param => {});
    dispatch({
      TAG: "FieldValueChanged",
      _0: "StockKeepingUnitIsDuplicate",
      _1: param => false
    });
  }, [value]);
  let queryResult = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, !ready, undefined, {
    filterBy: makeInputObjectInputVariantsQueryFilter({
      _in: Stdlib_Option.mapOr(activeShop, [], shop => [shop.id])
    }, {
      _equals: debouncedValue.trim()
    }, undefined, undefined, "EXCLUDED", undefined, undefined, undefined, undefined, undefined, undefined, undefined)
  });
  ReactUpdateEffect.use2(() => {
    let match = queryResult.data;
    if (ready && match !== undefined) {
      let duplicate = Stdlib_Option.map(match.variants.edges.find(param => {
        let node = param.node;
        return Stdlib_Option.mapOr(currentVariantId, true, id => node.id !== id);
      }), param => {
        let node = param.node;
        return {
          cku: node.cku,
          formattedName: node.formattedName
        };
      });
      setDuplicate(param => duplicate);
      dispatch({
        TAG: "FieldValueChanged",
        _0: "StockKeepingUnitIsDuplicate",
        _1: param => Stdlib_Option.isSome(duplicate)
      });
    }
  }, [
    debouncedValue,
    queryResult.data
  ]);
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(CatalogVariantEditForm.InputText.make, {
        field: "StockKeepingUnit",
        label: I18n.t("SKU code"),
        placeholder: "B1VAPSOBUOD202153C6",
        hideRequired: true,
        copyable: true
      }),
      duplicate !== undefined ? JsxRuntime.jsxs(NextBanner.make, {
          children: [
            JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t("catalog_variant.sku_duplicate.text")
            }),
            JsxRuntime.jsx(NextBanner.Text.make, {
              text: "➔ " + duplicate.formattedName,
              bold: true,
              href: CatalogRoutes.variantRoute(duplicate.cku),
              target: "_blank"
            })
          ],
          variation: "danger",
          compact: true,
          grow: true
        }) : null
    ],
    space: "small"
  });
}

let InputVariantStockKeepingUnit = {
  DuplicateCheckQuery: DuplicateCheckQuery,
  make: CatalogVariantEditFormInputs$InputVariantStockKeepingUnit
};

export {
  InputVariantCapacityValueSelect,
  InputVariantCapacityUnitSelect,
  InputVariantYear,
  InputVariantAlcoholVolume,
  InputVariantPriceLookup,
  InputVariantStockKeepingUnit,
}
/* query Not a pure module */
